import React from 'react';
import 'components/loader/_loader.scss';

function Loader() {
  return (
    <div className="loader-wrapper">
      <div className="loader"></div>
    </div>
  );
}

export default Loader;
